import { Pipe, PipeTransform } from "@angular/core";
import { Timestamp } from "@firebase/firestore-types";

@Pipe({
  name: "timestamp"
})
export class TimestampPipe implements PipeTransform {
  transform(maybeTimestamp: Date | Timestamp): Date {
    return TimestampPipe.asDate(maybeTimestamp);
  }

  public static asDate(date: Timestamp | Date) {
    if (date instanceof Date) {
      return date;
    }

    return TimestampPipe.timestampAsDate(date);
  }

  public static timestampAsDate(date: Timestamp) {
    if (!date) return new Date();
    return date?.toDate ? (date?.toDate() as any) : new Date(date?.seconds * 1000);
  }
}
